/**
 * Which backend dataset a request reads from: `v2` = legacy tables, `v3` =
 * unified. `null`/`undefined` mean no override, leaving the backend's normal
 * per-tenant routing.
 *
 * Only `v3` is ever put on the wire (`X-Data-Version` header or `?version=v3`),
 * so a v2 request is byte-identical to a pre-unification one. Helpers live in
 * `@hakimo-ui/hakimo/util` under `data-version/`.
 */
export type DataVersion = 'v2' | 'v3' | null;

/** The value an operator can pick in the internal toggle. Never null. */
export type DataVersionOverride = Extract<DataVersion, 'v2' | 'v3'>;

/** The only value we put on the wire. */
export const UNIFIED_DATA_VERSION = 'v3' as const;

/** Header used to pin a request to a specific dataset. */
export const DATA_VERSION_HEADER = 'X-Data-Version';

/** Query param used to pin a link/deep-link to a specific dataset. */
export const DATA_VERSION_PARAM = 'version';
